module.exports = __webpack_public_path__ + "img/9788980403325.c969fc9c.jpg";